import RolePermTypes from '../types/RolePermTypes';

const initialState = {
  isLoading: false,
  roleAllData: [],
  roleSingleData: [],
  activeRoleData: [],
  permAllData: [],
  permItemData: [],
  userPermItemData: [],
  userPermissions: {},
  noUserPermissions: false,
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const rolePermission = (state = initialState, action) => {
  switch (action.type) {
    case RolePermTypes.GET_ROLEPERM_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_ROLEPERM_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roleAllData: action.payload
      };
    case RolePermTypes.GET_ROLEPERM_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        listData: []
      };

    case RolePermTypes.GET_ROLEPERM_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_ROLEPERM_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        roleSingleData: action.payload
      };
    case RolePermTypes.GET_ROLEPERM_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        itemData: []
      };

    case RolePermTypes.GET_ROLEPERM_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_ROLEPERM_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeRoleData: action.payload
      };
    case RolePermTypes.GET_ROLEPERM_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        activeRoleData: []
      };

    case RolePermTypes.GET_ALL_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_ALL_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        permAllData: action.payload
      };
    case RolePermTypes.GET_ALL_PERMISSION_ERROR:
      return {
        ...state,
        isLoading: false,
        permAllData: []
      };

    case RolePermTypes.GET_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        permItemData: action.payload
      };
    case RolePermTypes.GET_PERMISSION_ERROR:
      return {
        ...state,
        isLoading: false,
        permItemData: []
      };

    case RolePermTypes.GET_USER_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_USER_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userPermItemData: action.payload
      };
    case RolePermTypes.GET_USER_PERMISSION_ERROR:
      return {
        ...state,
        isLoading: false,
        userPermItemData: []
      };

    case RolePermTypes.ASSIGN_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.ASSIGN_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false
        // userPermItemData: action.payload
      };
    case RolePermTypes.ASSIGN_PERMISSION_ERROR:
      return {
        ...state,
        isLoading: false
        // userPermItemData: []
      };

    case RolePermTypes.GET_CURRENT_USER_PERMISSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case RolePermTypes.GET_CURRENT_USER_PERMISSION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userPermissions: action.payload,
        noUserPermissions: action.noAccessPayload
      };
    case RolePermTypes.GET_CURRENT_USER_PERMISSION_ERROR:
      return {
        ...state,
        isLoading: false,
        userPermissions: {}
      };
    case RolePermTypes.UPDATE_ROLE_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paging,
          sortingData: action.payload.sorting,
          keyword: action.payload.keyword
        }
      };

    default:
      return state;
  }
};
export default rolePermission;
